<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-date</h2>
            <p class="demo-description">Date selector with modal, manual typing, and calendar support.</p>

            <div class="demo-controls">
                <ion-button size="small" (click)="toggleDisabled()">
                    Disabled: {{ disabled }}
                </ion-button>
            </div>

            <div class="demo-section" [formGroup]="form">
                <ion-item lines="none">
                    <upp-date
                        formControlName="date"
                        title="Start date"
                        placeholder="DD/MM/YYYY"
                    ></upp-date>
                </ion-item>
                <p class="demo-label">Value: <strong>{{ form.get('date')?.value }}</strong></p>
            </div>
        </div>
    </upp-scrollable>
</div>
